import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch(
          process.env.REACT_APP_API_URL + "/api/auth/me",
          {
            credentials: "include",
          }
        );
        const data = await res.json();
        if (data) {
          if (data.error) {
            setIsLoggedIn(false);
            return;
          } else {
            setIsLoggedIn(true);
          }
        } else {
          setIsLoggedIn(false);
        }
      } catch (err) {
        setIsLoggedIn(false);
      }
    };

    checkAuth();
  }, []);

  const login = () => {
    setIsLoggedIn(true);
  };

  const logout = async () => {
    try {
      await fetch(process.env.REACT_APP_API_URL + "/api/auth/logout", {
        credentials: "include",
      });
    } catch (err) {
      console.error("Logout failed", err);
    }

    localStorage.removeItem("showPublishingMessage");
    localStorage.removeItem("showBillingDetailsWarning");
    localStorage.removeItem("initials");
    localStorage.removeItem("firstName");

    setIsLoggedIn(false);
    window.location.href = "/ienakt";
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
